export const orgDb = {
    'Human': 'org.Hs.eg.db',
    'Rhesus monkey': 'org.Mmu.eg.db',
    'Chimp': 'org.Pt.eg.db',
    'Mouse': 'org.Mm.eg.db',
    'Rat': 'org.Rn.eg.db',
    'Pig': 'org.Ss.eg.db', 
    'Dog': 'org.Cf.eg.db',
    'Cattle': 'org.Bt.eg.db',
    'Chicken': 'org.Gg.eg.db', 
    'Zebrafish': 'org.Dr.eg.db',
    'African clawed frog': 'org.Xl.eg.db',
    'Fly': 'org.Dm.eg.db',
    'Anopheles': 'org.Ag.eg.db',
    'Worm': 'org.Ce.eg.db',
    'Arabidopsis': 'org.At.tair.db',
    'Yeast': 'org.Sc.sgd.db',
    'Malaria': 'org.Pf.plasmo.db',
    'E. coli strain K12': 'org.EcK12.eg.db',
    'E. coli strain Sakai': 'org.EcSakai.eg.db',
    'Myxococcus xanthus DK 1622': 'org.Mxanthus.db',
}